export default __webpack_public_path__ + "static/media/rake-structure-cn.f3e753ae.webp";